import React, { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { errorLogging } from '../../api/loggingApi';
import AppFallbackUI from './FallbackUI/AppFallbackUI';
import SceneFallbackUI from './FallbackUI/SceneFallbackUI';

const sendErrorReport = async (error, signal) => {
  const errorInfo = {
    userAgent: window.navigator.userAgent,
    errorMessage: `${error.toString()}\n\n${error.stack}`,
    clientVersion: import.meta.env.VITE_APP_VERSION,
    currentUrl: window.location.href,
  };
  try {
    await errorLogging(errorInfo, signal);
  } catch {
    console.error('Error logging failed');
  }
};

const ErrorBoundary = ({ appFallbackUI }) => {
  const error = useRouteError();

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (error && !import.meta.env.DEV) {
      sendErrorReport(error, signal);
    }
    return () => {
      controller.abort();
    };
  }, [error]);
  return appFallbackUI ? <AppFallbackUI /> : <SceneFallbackUI />;
};

export default ErrorBoundary;
